import { createSelector } from 'reselect';
import { NAMESPACE } from './constants';
import { selectStatus as ssoLoginStatus } from '../../services/SsoLogin/selectors';
import { LOADING as SSO_LOGIN_LOADING } from '../../services/SsoLogin/constants';

export const selectIsApexUserChecked = createSelector(
  (state) => state[NAMESPACE].isApexUserChecked,
  (val) => Boolean(val)
);

export const getLoadingStatus = createSelector(
  ssoLoginStatus,
  (results) => results === SSO_LOGIN_LOADING
);



// WEBPACK FOOTER //
// ./src/containers/Login/selectors.js